import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgBasicReview({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path d="M10.95 6.7a4.25 4.25 0 013.49 6.68l1.3 1.3a.75.75 0 11-1.05 1.06l-1.31-1.3a4.25 4.25 0 11-2.43-7.74M2.7 1.25a.75.75 0 010 1.5h-.2a.25.25 0 00-.25.25v9q.02.23.25.25H5a.75.75 0 010 1.5H2.5c-.97 0-1.75-.78-1.75-1.75V3c0-.97.78-1.75 1.75-1.75zm8.25 6.95a2.75 2.75 0 100 5.5 2.75 2.75 0 000-5.5M6 6.9a.75.75 0 010 1.5H4.5a.75.75 0 010-1.5zm3.5-2.7a.75.75 0 110 1.5h-5a.75.75 0 010-1.5zm2-2.95c.97 0 1.75.78 1.75 1.75v1.8a.75.75 0 01-1.5 0V3a.25.25 0 00-.25-.25h-.2a.75.75 0 010-1.5zM9 .2a1 1 0 011 1v.5a1 1 0 01-1 1H5a1 1 0 01-1-1v-.5a1 1 0 011-1z" />
    </svg>
  );
}

SvgBasicReview.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgBasicReview.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgBasicReview svgRef={ref} {...props} />);
export default ForwardRef;
